// @ts-nocheck
import React from "react";
import style from "./ChangePlan.module.scss";
import PropTypes from "prop-types";
import { InfoBtn } from "../../common/Payment/InfoBtn";
import { SecondaryBtn } from "../../common/Payment/SecondaryBtn";
import { getImageUrl } from "../../../commons/assets_path";
import { useTranslation } from "react-i18next";

export const ChangePlanPriceList = ({
  availableTrialPlans,
  pastTrialPlans,
  currentTrialPlan,
  plans,
  plan_prices,
  currentPlan,
  currentPaymentPeriod,
  selectPaymentPeriod,
  setSelectPaymentPeriod,
  setAfterPlanName,
  setAfterPlanCode,
  setTrialPlanName,
  setTrialPlanCode,
  handleShow,
  handleTrialShow,
  changePlanCheck,
  upOrDownCheck,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={style.changePlanList}>
        <div className={style.changePlanWrap}>
          <div className={style.changePlanTitle}>プラン変更</div>
          <div className={style.paymentSwitchWrap}>
            <div className={style.discountTag}>20%OFF</div>
            <div className={style.switchButton}>
              <div
                className={selectPaymentPeriod === "year" ? style.switchTypeActive : style.switchTypeDisable}
                onClick={() => setSelectPaymentPeriod("year")}
              >
                年間契約
              </div>
              <div
                className={selectPaymentPeriod === "month" ? style.switchTypeActive : style.switchTypeDisable}
                onClick={() => setSelectPaymentPeriod("month")}
              >
                月間・半年契約
              </div>
            </div>
          </div>
          <div className={style.changePlanType}>
            <div className={style.changePlanItemFree}>
              <div className={style.changePlanItemFreeGradation}></div>
              <div className={style.changePlanFree}>
                <div className={style.changePlanFreeTitle}>フリー</div>
                <div className={style.changePlanFreeDescription}>お試しの個人利用に最適</div>
              </div>
              <div className={style.changePlanFreeItemWrap}>
                <div className={style.changePlanFreeItem}>
                  <br />
                  <div className={style.changePlanFreeItemValue}>
                    <span className={style.changePlanFreeYen}>{plan_prices.currency_symbol}</span>
                    <span className={style.changePlanFreeItemAmount}>
                      {plan_prices.free.basic_price.toLocaleString()}
                    </span>
                    <span className={style.changePlanMiniYen} style={{ fontSize: "12px" }}>
                      /月
                    </span>
                  </div>
                </div>
                <div className={style.changePlanFreeItem}>
                  <div className={style.changePlanFreeItemContent}>
                    <div>
                      <span className={`${style.changePlanFreeItemContentBold} mr-1`}>
                        {plans.free.free_operation_boot_count.toLocaleString()}
                      </span>
                      回タスク実行無料
                    </div>
                    <div>
                      <span className={`${style.changePlanFreeItemContentBold} mr-1`}>
                        {plans.free.default_member_create_limit}
                      </span>
                      人ユーザー招待無料
                    </div>
                  </div>
                </div>
                <div className={style.changePlanFreeItem}>
                  <ul className={style.changePlanFreeItemList}>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      <strong>{plans.free.max_operation_count_per_workflow}オペレーション</strong>のフローボット
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      <strong>{plans.free.workflow_template_create_limit}個</strong>までのフローボット
                    </li>
                  </ul>
                </div>
                <div className={style.changePlanFreeButtonWrap} data-testid="change-plan-free-button-wrap">
                  {currentPlan?.plan_name === "フリー" ? (
                    <SecondaryBtn
                      text="現在のプラン"
                      disabled={true}
                      className={`test-force-upgrade ${style.changePlanFreeButton}`}
                    />
                  ) : (
                    <SecondaryBtn
                      text="ダウングレード"
                      disabled={false}
                      className={`test-force-upgrade ${style.changePlanFreeButton}`}
                      submit={() => {
                        setAfterPlanName("フリー");
                        setAfterPlanCode("free");
                        changePlanCheck("free");
                        handleShow();
                      }}
                      style={{ color: "#222222" }}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className={style.changePlanItemMini}>
              <div className={style.changePlanItemMiniGradation}></div>
              <div className={style.changePlanMini}>
                <div className={style.changePlanMiniTitle}>ミニ</div>
                <div className={style.changePlanMiniDescription}>
                  まずは簡単な業務を自動化して
                  <br />
                  みよう
                </div>
              </div>
              <div className={style.changePlanMiniItemWrap}>
                <div className={style.changePlanMiniItem}>
                  <span>{selectPaymentPeriod === "year" ? "　" : "月間契約"}</span>
                  <div className={style.changePlanMiniItemValue}>
                    <span className={style.changePlanMiniYen}>{plan_prices.currency_symbol}</span>
                    <span className={style.changePlanMiniItemAmount}>
                      {plan_prices.mini.basic_price[selectPaymentPeriod].toLocaleString()}
                    </span>
                    <span className={style.changePlanMiniYen} style={{ fontSize: "12px" }}>
                      /月
                    </span>
                  </div>
                </div>
                <div className={style.changePlanMiniItem}>
                  <div className={style.changePlanMiniItemContent}>
                    <div>
                      <span className={`${style.changePlanMiniItemContentBold} mr-1`}>
                        {plans.mini.free_operation_boot_count.toLocaleString()}
                      </span>
                      回タスク実行無料
                    </div>
                    <div>
                      <span className={`${style.changePlanMiniItemContentBold} mr-1`}>
                        {plans.mini.default_member_create_limit}
                      </span>
                      人ユーザー招待無料
                    </div>
                  </div>
                </div>
                <div className={style.changePlanMiniItem}>
                  <ul className={style.changePlanMiniItemList}>
                    <li className="mt-auto mb-1">
                      <strong>フリープランの機能に加えて</strong>
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      <strong>{plans.mini.max_operation_count_per_workflow}オペレーション</strong>のフローボット
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      <strong>{plans.mini.workflow_template_create_limit}個</strong>までのフローボット
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      フロー内の分岐設定
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      フォームのカスタマイズ
                    </li>
                  </ul>
                </div>
                <div className={style.changePlanMiniButtonWrap}>
                  {currentPlan?.plan_name === "ミニ" && currentPaymentPeriod === selectPaymentPeriod ? (
                    <SecondaryBtn
                      text="現在のプラン"
                      disabled={true}
                      className={`${style.changePlanMiniButton} test-force-upgrade`}
                    />
                  ) : availableTrialPlans.includes("mini") && !pastTrialPlans.includes("mini") ? (
                    <>
                      <InfoBtn
                        text="無料トライアル"
                        className={`${style.changePlanMiniButton} w-25 test-force-upgrade`}
                        submit={() => {
                          setTrialPlanName("ミニ");
                          setTrialPlanCode("mini");
                          handleTrialShow();
                        }}
                      />
                      <a
                        href="#"
                        className={`${style.changePlanMiniLink} w-25 test-force-upgrade`}
                        onClick={(e) => {
                          setAfterPlanName("ミニ");
                          setAfterPlanCode("mini");
                          upOrDownCheck(currentPlan.plan_name, "ミニ", currentPaymentPeriod, selectPaymentPeriod);
                          changePlanCheck("mini");
                          handleShow();
                        }}
                      >
                        今すぐミニに変更する
                      </a>
                    </>
                  ) : (
                    <>
                      <InfoBtn
                        text="ミニに変更"
                        className={`${style.changePlanMiniButton} w-25 test-force-upgrade`}
                        submit={() => {
                          setAfterPlanName("ミニ");
                          setAfterPlanCode("mini");
                          upOrDownCheck(currentPlan.plan_name, "ミニ", currentPaymentPeriod, selectPaymentPeriod);
                          changePlanCheck("mini");
                          handleShow();
                        }}
                      />
                      {currentTrialPlan === "mini" ? (
                        <span className={`${style.changePlanMiniPastTrial}`}>現在トライアル中</span>
                      ) : (
                        pastTrialPlans.includes("mini") && (
                          <span className={`${style.changePlanMiniPastTrial}`}>無料トライアル済み</span>
                        )
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className={style.changePlanItemTeam}>
              <div className={style.changePlanItemTeamGradation}></div>
              <div className={style.changePlanTeam}>
                <div className={style.changePlanTeamTitle}>チーム</div>
                <div className={style.changePlanTeamDescription}>
                  本格的に業務を自動化したい
                  <br />
                  チームに最適
                </div>
              </div>
              <div className={style.changePlanTeamItemWrap}>
                <div className={style.changePlanTeamItem}>
                  <span>{selectPaymentPeriod === "year" ? "　" : "月間契約"}</span>
                  <div className={style.changePlanTeamItemValue}>
                    <span className={style.changePlanTeamYen}>{plan_prices.currency_symbol}</span>
                    <span className={style.changePlanTeamItemAmount}>
                      {plan_prices.team.basic_price[selectPaymentPeriod].toLocaleString()}
                    </span>
                    <span className={style.changePlanMiniYen} style={{ fontSize: "12px" }}>
                      /月
                    </span>
                  </div>
                </div>
                <div className={style.changePlanTeamItem}>
                  <div className={style.changePlanTeamItemContent}>
                    <div>
                      <span className={`${style.changePlanTeamItemContentBold} mr-1`}>
                        {plans.team.free_operation_boot_count.toLocaleString()}
                      </span>
                      回タスク実行無料
                    </div>
                    <div>
                      <span className={`${style.changePlanTeamItemContentBold} mr-1`}>
                        {plans.team.default_member_create_limit}
                      </span>
                      人ユーザー招待無料
                    </div>
                  </div>
                </div>
                <div className={style.changePlanTeamItem}>
                  <ul className={style.changePlanTeamItemList}>
                    <li className="mt-auto mb-1">
                      <strong>ミニプランの機能に加えて</strong>
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      <strong>{plans.team.max_operation_count_per_workflow}オペレーション</strong>のフローボット
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      <strong>無制限</strong>のフローボット数
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      より柔軟なフロー設定
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      全てのアプリとの連携
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      独自APIとの連携
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      OCR
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      音声データの文字起こし
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      プロジェクトの権限設定
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      IP制限
                    </li>
                  </ul>
                </div>
                <div className={style.changePlanTeamButtonWrap}>
                  {currentPlan?.plan_name === "チーム" && currentPaymentPeriod === selectPaymentPeriod ? (
                    <SecondaryBtn
                      text="現在のプラン"
                      disabled={true}
                      className={`${style.changePlanTeamButton} test-force-upgrade`}
                    />
                  ) : availableTrialPlans.includes("team") && !pastTrialPlans.includes("team") ? (
                    <>
                      <InfoBtn
                        text="無料トライアル"
                        className={`${style.changePlanTeamButton} w-25 test-force-upgrade`}
                        submit={() => {
                          setTrialPlanName("チーム");
                          setTrialPlanCode("team");
                          handleTrialShow();
                        }}
                      />
                      <a
                        href="#"
                        className={`${style.changePlanTeamLink} w-25 test-force-upgrade`}
                        onClick={(e) => {
                          setAfterPlanName("チーム");
                          setAfterPlanCode("team");
                          upOrDownCheck(currentPlan.plan_name, "チーム", currentPaymentPeriod, selectPaymentPeriod);
                          changePlanCheck("team");
                          handleShow();
                        }}
                      >
                        今すぐチームに変更する
                      </a>
                    </>
                  ) : (
                    <>
                      <InfoBtn
                        text="チームに変更"
                        className={`${style.changePlanTeamButton} w-25 test-force-upgrade`}
                        submit={() => {
                          setAfterPlanName("チーム");
                          setAfterPlanCode("team");
                          upOrDownCheck(currentPlan.plan_name, "チーム", currentPaymentPeriod, selectPaymentPeriod);
                          changePlanCheck("team");
                          handleShow();
                        }}
                      />
                      {currentTrialPlan === "team" ? (
                        <span className={`${style.changePlanMiniPastTrial}`}>現在トライアル中</span>
                      ) : (
                        pastTrialPlans.includes("team") && (
                          <span className={`${style.changePlanMiniPastTrial}`}>無料トライアル済み</span>
                        )
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className={style.changePlanItemSuccess}>
              <div className={style.changePlanItemSuccessGradation}></div>
              <div className={style.changePlanSuccess}>
                <div className={style.changePlanSuccessTitle}>サクセス</div>
                <div className={style.changePlanSuccessDescription}>
                  カスタマーサクセスによる手厚
                  <br />
                  いサポートつき
                </div>
              </div>
              <div className={style.changePlanSuccessItemWrap}>
                <div className={style.changePlanSuccessItem}>
                  <span>{selectPaymentPeriod === "year" ? "　" : "半年契約"}</span>
                  <div className={style.changePlanSuccessItemValue}>
                    <span className={style.changePlanSuccessYen}>{plan_prices.currency_symbol}</span>
                    <span className={style.changePlanSuccessItemAmount}>
                      {plan_prices.success.basic_price[selectPaymentPeriod].toLocaleString()}
                    </span>
                    <span className={style.changePlanMiniYen} style={{ fontSize: "12px" }}>
                      /月
                    </span>
                  </div>
                </div>
                <div className={style.changePlanSuccessItem}>
                  <div className={style.changePlanSuccessItemContent}>
                    <div>
                      <span className={`${style.changePlanSuccessItemContentBold} mr-1`}>
                        {plans.success.free_operation_boot_count.toLocaleString()}
                      </span>
                      回タスク実行無料
                    </div>
                    <div>
                      <span className={`${style.changePlanSuccessItemContentBold} mr-1`}>
                        {plans.success.default_member_create_limit}
                      </span>
                      人ユーザー招待無料
                    </div>
                  </div>
                </div>
                <div className={style.changePlanSuccessItem}>
                  <ul className={style.changePlanSuccessItemList}>
                    <li className="mt-auto mb-1">
                      <strong>チームプランの機能に加えて</strong>
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      <strong>{plans.success.max_operation_count_per_workflow}オペレーション</strong>のフローボット
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      専門スタッフによる構築サポート
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      SAML認証によるSSO
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      フォームのカスタマイズ
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      二要素認証の必須化
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      ブラウザ操作の自動化
                    </li>
                  </ul>
                </div>
                <div className={style.changePlanSuccessButtonWrap}>
                  {currentPlan?.plan_name === "サクセス" &&
                  currentPaymentPeriod === (selectPaymentPeriod === "year" ? "year" : "half_year") ? (
                    <SecondaryBtn
                      text="現在のプラン"
                      disabled={true}
                      className={`${style.changePlanSuccessButton} test-force-upgrade`}
                    />
                  ) : availableTrialPlans.includes("success") && !pastTrialPlans.includes("success") ? (
                    <>
                      <InfoBtn
                        text="無料トライアル"
                        className={`${style.changePlanSuccessButton} w-25 test-force-upgrade`}
                        submit={() => {
                          setTrialPlanName("サクセス");
                          setTrialPlanCode("success");
                          handleTrialShow();
                        }}
                      />
                      <a
                        href="#"
                        className={`${style.changePlanSuccessLink} w-25 test-force-upgrade`}
                        onClick={(e) => {
                          setAfterPlanName("サクセス");
                          setAfterPlanCode("success");
                          upOrDownCheck(
                            currentPlan.plan_name,
                            "サクセス",
                            currentPaymentPeriod,
                            selectPaymentPeriod === "year" ? "year" : "half_year",
                          );
                          changePlanCheck("success");
                          handleShow();
                        }}
                      >
                        今すぐサクセスに変更する
                      </a>
                    </>
                  ) : (
                    <>
                      <InfoBtn
                        text="サクセスに変更"
                        className={`${style.changePlanSuccessButton} w-25 test-force-upgrade`}
                        submit={() => {
                          setAfterPlanName("サクセス");
                          setAfterPlanCode("success");
                          upOrDownCheck(
                            currentPlan.plan_name,
                            "サクセス",
                            currentPaymentPeriod,
                            selectPaymentPeriod === "year" ? "year" : "half_year",
                          );
                          changePlanCheck("success");
                          handleShow();
                        }}
                      />
                      {currentTrialPlan === "success" ? (
                        <span className={`${style.changePlanMiniPastTrial}`}>現在トライアル中</span>
                      ) : (
                        pastTrialPlans.includes("success") && (
                          <span className={`${style.changePlanMiniPastTrial}`}>無料トライアル済み</span>
                        )
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className={style.changePlanPriceListTitle}>プラン比較</div>
          <div className={style.changePlanPriceList}>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitleStart}>プラン</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueStartFree}>フリー</div>
                <div className={style.changePlanPriceValueStartMini}>ミニ</div>
                <div className={style.changePlanPriceValueStartTeam}>チーム</div>
                <div className={style.changePlanPriceValueStartSuccess}>サクセス</div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>契約期間</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}></div>
                <div className={style.changePlanPriceValueMini}>
                  {selectPaymentPeriod === "month" ? "月間契約" : "年間契約"}
                </div>
                <div className={style.changePlanPriceValueTeam}>
                  {selectPaymentPeriod === "month" ? "月間契約" : "年間契約"}
                </div>
                <div className={style.changePlanPriceValueSuccess}>
                  {selectPaymentPeriod === "month" ? "半年契約" : "年間契約"}
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>月の無料タスク数</div>
              <div className={style.changePlanPriceValueWrap}>
                <div
                  className={style.changePlanPriceValueFree}
                >{`${plans.free.free_operation_boot_count.toLocaleString()}回`}</div>
                <div
                  className={style.changePlanPriceValueMini}
                >{`${plans.mini.free_operation_boot_count.toLocaleString()}回`}</div>
                <div
                  className={style.changePlanPriceValueTeam}
                >{`${plans.team.free_operation_boot_count.toLocaleString()}回`}</div>
                <div
                  className={style.changePlanPriceValueSuccess}
                >{`${plans.success.free_operation_boot_count.toLocaleString()}回`}</div>
              </div>
            </div>
            <div className={style.changePlanTaskRowItems}>
              <div className={style.changePlanTaskTitle}>追加タスク料金</div>
              <div className={style.changePlanTaskValueWrap}>
                <div className={style.changePlanTaskValueFree}></div>
                <div className={style.changePlanTaskValueMini}>
                  <span>1タスク追加ごとに</span>
                  <span className={style.changePlanTaskValuePrice}>{`${
                    plan_prices.currency_symbol
                  }${plan_prices.mini.operation_boot_price.unit_amount_decimal_range[
                    selectPaymentPeriod
                  ].toLocaleString()}`}</span>
                </div>
                <div className={style.changePlanTaskValueTeam}>
                  <span>1タスク追加ごとに</span>
                  <span className={style.changePlanTaskValuePrice}>{`${
                    plan_prices.currency_symbol
                  }${plan_prices.team.operation_boot_price.unit_amount_decimal_range[
                    selectPaymentPeriod
                  ].toLocaleString()}`}</span>
                </div>
                <div className={style.changePlanTaskValueSuccess}>
                  <span>1タスク追加ごとに</span>
                  <span className={style.changePlanTaskValuePrice}>{`${
                    plan_prices.currency_symbol
                  }${plan_prices.success.operation_boot_price.unit_amount_decimal_range[
                    selectPaymentPeriod
                  ].toLocaleString()}`}</span>
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>無料ライセンス数</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>{`${plans.free.default_member_create_limit}名`}</div>
                <div className={style.changePlanPriceValueMini}>{`${plans.mini.default_member_create_limit}名`}</div>
                <div className={style.changePlanPriceValueTeam}>{`${plans.team.default_member_create_limit}名`}</div>
                <div
                  className={style.changePlanPriceValueSuccess}
                >{`${plans.success.default_member_create_limit}名`}</div>
              </div>
            </div>
            <div className={style.changePlanTaskRowItems}>
              <div className={style.changePlanTaskTitle}>追加ライセンス料金</div>
              <div className={style.changePlanTaskValueWrap}>
                <div className={style.changePlanTaskValueFree}></div>
                <div className={style.changePlanTaskValueMini}></div>
                <div className={style.changePlanTaskValueTeam}>
                  <span>1ライセンスごとに</span>
                  <span className={style.changePlanTaskValuePrice}>{`${
                    plan_prices.currency_symbol
                  }${plan_prices.team.license_price[selectPaymentPeriod].toLocaleString()}/月`}</span>
                </div>
                <div className={style.changePlanTaskValueSuccess}>
                  <span>1ライセンスごとに</span>
                  <span className={style.changePlanTaskValuePrice}>{`${
                    plan_prices.currency_symbol
                  }${plan_prices.success.license_price[selectPaymentPeriod].toLocaleString()}/月`}</span>
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>プロジェクト作成数</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>{plans.free.custom_sections_limit}</div>
                <div className={style.changePlanPriceValueMini}>{plans.mini.custom_sections_limit}</div>
                <div className={style.changePlanPriceValueTeam}>{plans.team.custom_sections_limit}</div>
                <div className={style.changePlanPriceValueSuccess}>{plans.success.custom_sections_limit}</div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>プロジェクト権限</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}></div>
                <div className={style.changePlanPriceValueMini}></div>
                <div className={style.changePlanPriceValueTeam}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
                <div className={style.changePlanPriceValueSuccess}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>フローボット作成数</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>{plans.free.workflow_template_create_limit}</div>
                <div className={style.changePlanPriceValueMini}>{plans.mini.workflow_template_create_limit}</div>
                <div className={style.changePlanPriceValueTeam}>無制限</div>
                <div className={style.changePlanPriceValueSuccess}>無制限</div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>
                1フローボットの
                <br />
                オペレーション数
              </div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>{plans.free.max_operation_count_per_workflow}</div>
                <div className={style.changePlanPriceValueMini}>{plans.mini.max_operation_count_per_workflow}</div>
                <div className={style.changePlanPriceValueTeam}>{plans.team.max_operation_count_per_workflow}</div>
                <div className={style.changePlanPriceValueSuccess}>
                  {plans.success.max_operation_count_per_workflow}
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>連携可能なアプリ</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>
                  <a
                    className="m-0"
                    href="https://intercom.help/yoom/ja/articles/8885225"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    一部のアプリ
                  </a>
                  を除く
                </div>
                <div className={style.changePlanPriceValueMini}>
                  <a
                    className="m-0"
                    href="https://intercom.help/yoom/ja/articles/8885225"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    一部のアプリ
                  </a>
                  を除く
                </div>
                <div className={style.changePlanPriceValueTeam}>すべてのアプリ</div>
                <div className={style.changePlanPriceValueSuccess}>すべてのアプリ</div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>
                独自APIとの連携
                <br />
                (カスタムアプリ・
                <br />
                アクション)
              </div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}></div>
                <div className={style.changePlanPriceValueMini}></div>
                <div className={style.changePlanPriceValueTeam}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
                <div className={style.changePlanPriceValueSuccess}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>OCR</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}></div>
                <div className={style.changePlanPriceValueMini}></div>
                <div className={style.changePlanPriceValueTeam}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
                <div className={style.changePlanPriceValueSuccess}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>音声データの文字起こし</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}></div>
                <div className={style.changePlanPriceValueMini}></div>
                <div className={style.changePlanPriceValueTeam}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
                <div className={style.changePlanPriceValueSuccess}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>ブラウザ操作の自動化</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}></div>
                <div className={style.changePlanPriceValueMini}></div>
                <div className={style.changePlanPriceValueTeam}></div>
                <div className={style.changePlanPriceValueSuccess}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>オペレーション間の操作</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>-</div>
                <div className={style.changePlanPriceValueMini}>
                  <span style={{ fontSize: "12px" }}>
                    分岐・
                    <br />
                    進行先切り替え・移動
                  </span>
                </div>
                <div className={style.changePlanPriceValueTeam}>全ての操作</div>
                <div className={style.changePlanPriceValueSuccess}>全ての操作</div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>フォームのカスタマイズ</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>-</div>
                <div className={style.changePlanPriceValueMini}>
                  <span>
                    <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                    （IP制限以外）
                  </span>
                </div>
                <div className={style.changePlanPriceValueTeam}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
                <div className={style.changePlanPriceValueSuccess}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>Webhook受信上限</div>
              <div className={style.changePlanPriceValueWrap}>
                <div
                  className={style.changePlanPriceValueFree}
                >{`${plans.free.webhook_trigger_receive_limit} / 1分間`}</div>
                <div
                  className={style.changePlanPriceValueMini}
                >{`${plans.mini.webhook_trigger_receive_limit} / 1分間`}</div>
                <div
                  className={style.changePlanPriceValueTeam}
                >{`${plans.team.webhook_trigger_receive_limit} / 1分間`}</div>
                <div
                  className={style.changePlanPriceValueSuccess}
                >{`${plans.success.webhook_trigger_receive_limit}/ 1分間`}</div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>トリガー起動間隔</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>15分に1度</div>
                <div className={style.changePlanPriceValueMini}>10分に1度</div>
                <div className={style.changePlanPriceValueTeam}>5分に1度</div>
                <div className={style.changePlanPriceValueSuccess}>5分に1度</div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>{t("ChangePlanPriceList.saved_values_count")}</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>
                  {plans.free.max_output_count_per_workflow.toLocaleString()}
                </div>
                <div className={style.changePlanPriceValueMini}>
                  {plans.mini.max_output_count_per_workflow.toLocaleString()}
                </div>
                <div className={style.changePlanPriceValueTeam}>
                  {plans.team.max_output_count_per_workflow.toLocaleString()}
                </div>
                <div className={style.changePlanPriceValueSuccess}>
                  {plans.success.max_output_count_per_workflow.toLocaleString()}
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>データベース作成数</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>
                  {plans.free.dynamic_database_limit.toLocaleString()}
                </div>
                <div className={style.changePlanPriceValueMini}>
                  {plans.mini.dynamic_database_limit.toLocaleString()}
                </div>
                <div className={style.changePlanPriceValueTeam}>
                  {plans.team.dynamic_database_limit.toLocaleString()}
                </div>
                <div className={style.changePlanPriceValueSuccess}>
                  {plans.success.dynamic_database_limit.toLocaleString()}
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>
                1テーブルあたり
                <br />
                データーベーストリガー数
              </div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>{plans.free.db_trigger_table_active_limit}</div>
                <div className={style.changePlanPriceValueMini}>{plans.mini.db_trigger_table_active_limit}</div>
                <div className={style.changePlanPriceValueTeam}>{plans.team.db_trigger_table_active_limit}</div>
                <div className={style.changePlanPriceValueSuccess}>{plans.success.db_trigger_table_active_limit}</div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>データベース容量</div>
              <div className={style.changePlanPriceValueWrap}>
                <div
                  className={style.changePlanPriceValueFree}
                >{`99列 × ${plans.free.dynamic_table_record_limit.toLocaleString()}行`}</div>
                <div
                  className={style.changePlanPriceValueMini}
                >{`99列 × ${plans.mini.dynamic_table_record_limit.toLocaleString()}行`}</div>
                <div
                  className={style.changePlanPriceValueTeam}
                >{`99列 × ${plans.team.dynamic_table_record_limit.toLocaleString()}行`}</div>
                <div
                  className={style.changePlanPriceValueSuccess}
                >{`99列 × ${plans.success.dynamic_table_record_limit.toLocaleString()}行`}</div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>データコネクトの同期頻度</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>1日に1回</div>
                <div className={style.changePlanPriceValueMini}>6時間に1回</div>
                <div className={style.changePlanPriceValueTeam}>1時間に1回</div>
                <div className={style.changePlanPriceValueSuccess}>1時間に1回</div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>ゲスト招待</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>{`${plans.free.guest_create_limit}名`}</div>
                <div className={style.changePlanPriceValueMini}>{`${plans.mini.guest_create_limit}名`}</div>
                <div className={style.changePlanPriceValueTeam}>{`${plans.team.guest_create_limit}名`}</div>
                <div className={style.changePlanPriceValueSuccess}>{`${plans.success.guest_create_limit}名`}</div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>IP制限</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}></div>
                <div className={style.changePlanPriceValueMini}></div>
                <div className={style.changePlanPriceValueTeam}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
                <div className={style.changePlanPriceValueSuccess}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>SAML認証によるSSO</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}></div>
                <div className={style.changePlanPriceValueMini}></div>
                <div className={style.changePlanPriceValueTeam}></div>
                <div className={style.changePlanPriceValueSuccess}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>2要素認証の必須化</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}></div>
                <div className={style.changePlanPriceValueMini}></div>
                <div className={style.changePlanPriceValueTeam}></div>
                <div className={style.changePlanPriceValueSuccess}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>サポート</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>チャット</div>
                <div className={style.changePlanPriceValueMini}>チャット</div>
                <div className={style.changePlanPriceValueTeam}>メール・チャット（優先対応）</div>
                <div className={style.changePlanPriceValueSuccess}>
                  <span style={{ fontSize: "12px" }}>メール・チャット・</span>
                  <span style={{ fontSize: "12px" }}>Web会議(月2回まで)</span>
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitleEnd}>専門スタッフの構築支援</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueEndFree}></div>
                <div className={style.changePlanPriceValueEndMini}></div>
                <div className={style.changePlanPriceValueEndTeam}></div>
                <div className={style.changePlanPriceValueEndSuccess}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems} style={{ marginTop: "24px" }}>
              <div className={style.changePlanPriceValueWrap}>
                <div style={{ marginLeft: "12px", marginRight: "12px" }}>
                  {currentPlan?.plan_name === "フリー" ? (
                    <SecondaryBtn
                      text="現在のプラン"
                      disabled={true}
                      className={`test-force-upgrade ${style.changePlanFreeButton}`}
                    />
                  ) : (
                    <SecondaryBtn
                      text="ダウングレード"
                      disabled={false}
                      className={`test-force-upgrade ${style.changePlanFreeButton}`}
                      submit={() => {
                        setAfterPlanName("フリー");
                        setAfterPlanCode("free");
                        changePlanCheck("free");
                        handleShow();
                      }}
                    />
                  )}
                </div>
                <div style={{ marginLeft: "12px", marginRight: "12px" }}>
                  {currentPlan?.plan_name === "ミニ" && currentPaymentPeriod === selectPaymentPeriod ? (
                    <SecondaryBtn
                      text="現在のプラン"
                      disabled={true}
                      className={`${style.changePlanMiniButton} test-force-upgrade`}
                    />
                  ) : availableTrialPlans.includes("mini") && !pastTrialPlans.includes("mini") ? (
                    <InfoBtn
                      text="無料トライアル"
                      className={`${style.changePlanMiniButton} test-force-upgrade`}
                      submit={() => {
                        setTrialPlanName("ミニ");
                        setTrialPlanCode("mini");
                        handleTrialShow();
                      }}
                    />
                  ) : (
                    <>
                      <InfoBtn
                        text="ミニに変更"
                        className={`${style.changePlanMiniButton} test-force-upgrade`}
                        submit={() => {
                          setAfterPlanName("ミニ");
                          setAfterPlanCode("mini");
                          upOrDownCheck(currentPlan.plan_name, "ミニ", currentPaymentPeriod, selectPaymentPeriod);
                          changePlanCheck("mini");
                          handleShow();
                        }}
                      />
                    </>
                  )}
                </div>
                <div style={{ marginLeft: "12px", marginRight: "12px" }}>
                  {currentPlan?.plan_name === "チーム" && currentPaymentPeriod === selectPaymentPeriod ? (
                    <SecondaryBtn
                      text="現在のプラン"
                      disabled={true}
                      className={`${style.changePlanTeamButton} test-force-upgrade`}
                    />
                  ) : availableTrialPlans.includes("team") && !pastTrialPlans.includes("team") ? (
                    <InfoBtn
                      text="無料トライアル"
                      className={`${style.changePlanTeamButton} test-force-upgrade`}
                      submit={() => {
                        setTrialPlanName("チーム");
                        setTrialPlanCode("team");
                        handleTrialShow();
                      }}
                    />
                  ) : (
                    <InfoBtn
                      text="チームに変更"
                      className={`${style.changePlanTeamButton} test-force-upgrade`}
                      submit={() => {
                        setAfterPlanName("チーム");
                        setAfterPlanCode("team");
                        upOrDownCheck(currentPlan.plan_name, "チーム", currentPaymentPeriod, selectPaymentPeriod);
                        changePlanCheck("team");
                        handleShow();
                      }}
                    />
                  )}
                </div>
                <div style={{ marginLeft: "12px", marginRight: "12px" }}>
                  {currentPlan?.plan_name === "サクセス" &&
                  currentPaymentPeriod === (selectPaymentPeriod === "year" ? "year" : "half_year") ? (
                    <SecondaryBtn
                      text="現在のプラン"
                      disabled={true}
                      className={`${style.changePlanSuccessButton} test-force-upgrade`}
                    />
                  ) : availableTrialPlans.includes("success") && !pastTrialPlans.includes("success") ? (
                    <InfoBtn
                      text="無料トライアル"
                      className={`${style.changePlanSuccessButton} test-force-upgrade`}
                      submit={() => {
                        setTrialPlanName("サクセス");
                        setTrialPlanCode("success");
                        handleTrialShow();
                      }}
                    />
                  ) : (
                    <InfoBtn
                      text="サクセスに変更"
                      className={`${style.changePlanSuccessButton} test-force-upgrade`}
                      submit={() => {
                        setAfterPlanName("サクセス");
                        setAfterPlanCode("success");
                        upOrDownCheck(
                          currentPlan.plan_name,
                          "サクセス",
                          currentPaymentPeriod,
                          selectPaymentPeriod === "year" ? "year" : "half_year",
                        );
                        changePlanCheck("success");
                        handleShow();
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
            <div style={{ marginTop: "20px", marginBottom: "20px", marginLeft: "10px" }}>
              <div>
                ※ 料金・プラン・お支払いに関する詳細は
                <a
                  className="m-0"
                  href="https://intercom.help/yoom/ja/collections/3480938"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  こちら
                </a>
                をご確認ください。
              </div>
              <div>※ 価格はすべて税別です。</div>
              <div>※ お支払いは月末締翌月初請求書発行です。</div>
              <div>※ プランはすべて自動更新です。プラン変更を希望の場合は、更新日までに変更をお願いいたします。</div>
              <div>※ 半年契約・月間契約は、契約期間分を一括でお支払いいただきます。返金は承っておりません。</div>
              <div>
                ※ タスクのカウント方法については
                <a
                  className="m-0"
                  href="https://intercom.help/yoom/ja/articles/7949340"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  こちら
                </a>
                をご確認ください。
              </div>
              <div>※ サクセスプランに月間契約はありません。ミニプラン・チームプランに半年契約はありません。</div>
              <div>
                ※
                申込初月の基本料金は、申込日が11~20日の場合は基本料金の2/3の料金、申込日が21日〜末日の場合は基本料金の1/3の料金をご請求いたします。月の途中で有料プランから有料プランにアップグレードした場合は、変更日に関わらず、プラン変更後の基本料金を適用します。割引は行いませんので、ご注意ください。
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

ChangePlanPriceList.propTypes = {
  availableTrialPlans: PropTypes.array,
  pastTrialPlans: PropTypes.array,
  currentTrialPlan: PropTypes.string,
  plans: PropTypes.object,
  plan_prices: PropTypes.object,
  currentPlan: PropTypes.object,
  currentPaymentPeriod: PropTypes.string,
  selectPaymentPeriod: PropTypes.string,
  setSelectPaymentPeriod: PropTypes.func,
  setAfterPlanName: PropTypes.func,
  setAfterPlanCode: PropTypes.func,
  setTrialPlanName: PropTypes.func,
  setTrialPlanCode: PropTypes.func,
  handleShow: PropTypes.func,
  handleTrialShow: PropTypes.func,
  changePlanCheck: PropTypes.func,
  upOrDownCheck: PropTypes.func,
};
